"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnalyticsOptionsDefaults = exports.getAnalyticsOptions = exports.getLSEnv = void 0;
const enums_1 = require("../enums");
const platform_generic_1 = require("./gtm/platform-generic");
const interface_1 = require("./interface");
const getLSEnv = (hostname) => {
    let out = interface_1.LSEnv.Prod;
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(interface_1.LSEnvDomainPrefix.Dev)) {
        out = interface_1.LSEnv.Dev;
    }
    if ((hostname === null || hostname === void 0 ? void 0 : hostname.includes(interface_1.LSEnvDomainPrefix.Local)) ||
        (hostname === null || hostname === void 0 ? void 0 : hostname.includes(`localhost`)) ||
        hostname === 'localhost') {
        out = interface_1.LSEnv.Local;
    }
    if (hostname === null || hostname === void 0 ? void 0 : hostname.includes(interface_1.LSEnvDomainPrefix.Uat)) {
        out = interface_1.LSEnv.Uat;
    }
    return out;
};
exports.getLSEnv = getLSEnv;
const getAnalyticsOptions = (hostname, envArgs, env) => {
    env = env ? env : (0, exports.getLSEnv)(hostname);
    const gtmService = env ? envArgs[env] : envArgs[interface_1.LSEnv.Dev];
    const client = enums_1.AnalyticServiceVendor.GoogleTagManager;
    const config = { gtmService };
    return { client, config };
};
exports.getAnalyticsOptions = getAnalyticsOptions;
const getAnalyticsOptionsDefaults = (hostname) => {
    const env = (0, exports.getLSEnv)(hostname);
    const gtmService = env
        ? platform_generic_1.PlatformGenericConfig[env]
        : platform_generic_1.PlatformGenericConfig[interface_1.LSEnv.Prod];
    const client = enums_1.AnalyticServiceVendor.GoogleTagManager;
    const config = { gtmService };
    return { client, config };
};
exports.getAnalyticsOptionsDefaults = getAnalyticsOptionsDefaults;
//# sourceMappingURL=gtm.js.map